<mat-card appearance="outlined" class="container-ffurflen">
    <formly-group [field]="field"></formly-group>
</mat-card>